module.exports = __webpack_public_path__ + "static/media/event_blocker.03295e99.png";